/*
  Rollbar is attached to the window via separate script tag (served to document by rails).
  The import is used to get the TS type, and so the package can remain a dev dependency.
*/
/* eslint-disable import/no-extraneous-dependencies */
import type Rollbar from 'rollbar'

const dispatchRollbarError = (...args: Rollbar.LogArgument[]) => {
  // @ts-ignore -- window global not typed yet
  const instance: Rollbar | undefined = window?.Rollbar

  if (!instance) return

  instance.error(...args)
}

// Attach the signed-in user to error reports. The server snippet boots Rollbar
// without a person so the page stays edge-cacheable; this restores it client-side.
const configureRollbarPerson = (id: number | string) => {
  // @ts-ignore -- window global not typed yet
  const instance: Rollbar | undefined = window?.Rollbar

  if (!instance) return

  instance.configure({ payload: { person: { id: String(id) } } })
}

export { dispatchRollbarError, configureRollbarPerson }
